import { render, staticRenderFns } from "./XuQiuLeiBie.vue?vue&type=template&id=0d052d08&scoped=true&"
import script from "./XuQiuLeiBie.vue?vue&type=script&lang=js&"
export * from "./XuQiuLeiBie.vue?vue&type=script&lang=js&"
import style0 from "./XuQiuLeiBie.vue?vue&type=style&index=0&id=0d052d08&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d052d08",
  null
  
)

export default component.exports